var map = {
	"./background_sounds.png": 531,
	"./backgrounds.png": 532,
	"./beak.png": 1721,
	"./body.png": 1722,
	"./bookshelves.png": 533,
	"./eyes.png": 1723,
	"./face.png": 1724,
	"./feet.png": 1725,
	"./floor_items.png": 1726,
	"./furniture_icon.png": 1727,
	"./greetings.png": 1728,
	"./head.png": 1729,
	"./houses.png": 534,
	"./left_hand.png": 1730,
	"./owl_hoots.png": 535,
	"./sofas.png": 536,
	"./titles.png": 537,
	"./wall_items.png": 538
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 670;



//////////////////
// WEBPACK FOOTER
// ./assets/images/owl-item-types .\.png*
// module id = 670
// module chunks = 0